import { NgModule } from "@angular/core";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { MapAbortDrawComponent } from "./components/menu/map-abort-draw/map-abort-draw.component";
import { CollectorService } from "./components/menu/map-collector/collector.service";
import { MapCollectorComponent } from "./components/menu/map-collector/map-collector.component";
import { MapDrawComponent } from "./components/menu/map-draw/map-draw.component";
import { MapExtentComponent } from "./components/menu/map-extent/map-extent.component";
import { MapFastighetComponent } from "./components/menu/map-fastighet/map-fastighet.component";
import { MapFastighetService } from "./components/menu/map-fastighet/map-fastighet.service";
import { MapFullscreenComponent } from "./components/menu/map-fullscreen/map-fullscreen.component";
import { MapHomeComponent } from "./components/menu/map-home/map-home.component";
import { MapLayersComponent } from "./components/menu/map-layers/map-layers.component";
import { MapMeasureComponent } from "./components/menu/map-measure/map-measure.component";
import { MapMenuButtonComponent } from "./components/menu/map-menu-button/map-menu-button.component";
import { MapSelectComponent } from "./components/menu/map-select/map-select.component";
import { MapViapunkterComponent } from "./components/menu/map-viapunkter/map-viapunkter.component";
import { EditMenuComponent } from "./components/widgets/edit-menu/edit-menu.component";
import { InformationPopupComponent } from "./components/widgets/edit-menu/information-popup/information-popup.component";
import { GeometriesListModule } from "./components/widgets/geometries-list/geometries-list.module";
import { LayerErrorMessageComponent } from "./components/widgets/layer-error-message/layer-error-message.component";
import { MapPopupContentComponent } from "./components/widgets/map-popup/map-popup-content/map-popup-content.component";
import { MapPopupComponent } from "./components/widgets/map-popup/map-popup.component";
import { MapPopupService } from "./components/widgets/map-popup/map-popup.service";
import { MapTabWidgetComponent } from "./components/widgets/map-tab-widget/map-tab-widget.component";
import { MapWidgetTabComponent } from "./components/widgets/map-tab-widget/map-widget-tab/map-widget-tab.component";
import { NavigateComponent } from "./components/widgets/navigate/navigate.component";
import { RightClickPopupComponent } from "./components/widgets/right-click-popup/right-click-popup.component";
import { MapComponent } from "./map.component";
import { MapEditService } from "./services/map-edit.service";
import { MapSketch2Service } from "./services/map-sketch2.service";
import { SpatialService } from "./services/spatial.service";
import { SymbolService } from "./services/symbol.service";
import { TerraformerService } from "./services/terraformer.service";

@NgModule({
    imports: [
        GeometriesListModule,
        NgbTooltipModule,
        RaskCommonModule,
        MapComponent,
        MapPopupComponent,
        MapExtentComponent,
        MapMeasureComponent,
        MapFastighetComponent,
        MapDrawComponent,
        MapPopupContentComponent,
        MapCollectorComponent,
        MapSelectComponent,
        MapTabWidgetComponent,
        MapWidgetTabComponent,
        MapMenuButtonComponent,
        MapFullscreenComponent,
        MapLayersComponent,
        MapViapunkterComponent,
        EditMenuComponent,
        MapAbortDrawComponent,
        InformationPopupComponent,
        MapHomeComponent,
        RightClickPopupComponent,
        NavigateComponent,
        LayerErrorMessageComponent
    ],
    exports: [
        MapComponent,
        MapExtentComponent,
        MapMeasureComponent,
        MapFastighetComponent,
        MapDrawComponent,
        MapPopupContentComponent,
        MapCollectorComponent,
        MapSelectComponent,
        MapTabWidgetComponent,
        MapWidgetTabComponent,
        MapFullscreenComponent,
        MapLayersComponent,
        MapViapunkterComponent,
        MapAbortDrawComponent,
        MapHomeComponent,
        NavigateComponent
    ],
    providers: [
        MapPopupService,
        SpatialService,
        SymbolService,
        MapFastighetService,
        CollectorService,
        MapSketch2Service,
        MapEditService,
        TerraformerService
    ]
})
export class MapModule {
}
